export default Object.freeze({
    NETWORK: 'NETWORK',
    PREMIUM: 'PREMIUM',
    TRIAL_PERIOD: 'TRIAL_PERIOD',
    ENTERPRISE: 'ENTERPRISE',
})
